// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"8":"f6fadc34","125":"0e2bc64f","211":"ceacba6f","288":"fdace5ea","906":"fa2cebcd"}[chunkId] + ".css";
};